/** Session packages: the catalogue, what customers bought, balances on a customer. Conventions: see `common.ts`. */
const bookingPackages: Record<string, string> = {
  nav_label: 'Packages',
  title: 'Packages',
  intro:
    'Sell sessions up front - "5 physiotherapy sessions" or "10 blow-dries". Customers pay once on your storefront, then book those services with a credit instead of paying each time.',
  read_only: 'You can see the packages but not change them.',
  loading: 'Loading packages…',
  load_error: 'Packages could not be loaded. Please try again.',
  generic_error: 'Something went wrong. Please try again.',
  empty_title: 'No packages yet',
  empty_description: 'Bundle a few sessions of your services at one price. Regular customers come back, and you are paid in advance.',
  add: 'Add package',
  edit: 'Edit',
  delete: 'Delete',
  deleted: 'Package deleted',
  saved: 'Package saved',
  visible: 'On sale',
  hidden: 'Hidden',
  sessions_count_one: '{count} session',
  sessions_count_other: '{count} sessions',
  no_expiry: 'Never expires',
  valid_days: 'Valid {days} days',
  service_removed: 'A service that was deleted',
  not_entitled: 'Selling packages needs online booking payments, which your plan does not include.',
  see_plans: 'See plans',
  payments_off: 'Customers can buy these once online booking payments are switched on.',
  open_bookings: 'Open Bookings',
  tabs_label: 'Packages and purchases',
  'tabs.packages': 'Packages',
  'tabs.purchases': 'Purchases',
  delete_title: 'Delete this package?',
  delete_confirm: 'Delete "{name}"? Customers who already bought it keep their sessions.',

  'form.add_title': 'Add package',
  'form.edit_title': 'Edit package',
  'form.cancel': 'Cancel',
  'form.save': 'Save',
  'form.saving': 'Saving…',
  'form.name': 'Name',
  'form.name_placeholder': '5 physiotherapy sessions',
  'form.description': 'Description',
  'form.services': 'Can be used for',
  'form.services_empty': 'Add a service on the Services page first.',
  'form.sessions': 'Sessions',
  'form.price': 'Price (₹)',
  'form.validity_days': 'Valid for (days)',
  'form.validity_days_hint': 'Leave empty to never expire.',
  'form.is_active': 'On sale',

  'errors.required': 'This field is required.',
  'errors.services': 'Pick at least one service.',
  'errors.sessions': 'Enter whole sessions between 1 and {max}.',
  'errors.price': 'Enter a price above ₹0.',
  'errors.validity': 'Enter whole days between 1 and {max}, or leave it empty.',

  'purchase_status.AWAITING_PAYMENT': 'Awaiting payment',
  'purchase_status.ACTIVE': 'Active',
  'purchase_status.EXHAUSTED': 'Used up',
  'purchase_status.EXPIRED': 'Expired',
  'purchase_status.CANCELLED': 'Cancelled',
  'purchase_status.REFUNDED': 'Refunded',

  'purchases.filter': 'Status',
  'purchases.filter_all': 'All statuses',
  'purchases.loading': 'Loading purchases…',
  'purchases.load_error': 'Purchases could not be loaded. Please try again.',
  'purchases.empty': 'Nobody has bought a package yet.',
  'purchases.empty_customer': 'This customer has no packages.',
  'purchases.customer': 'Customer',
  'purchases.sessions_used': '{used} of {total} used · {left} left',
  'purchases.bought_on': 'Bought {date}',
  'purchases.expires_on': 'Expires {date}',
  'purchases.adjust': 'Adjust sessions',
  'purchases.cancel': 'Cancel',
  'purchases.refund': 'Refund',
  'purchases.cancelled': 'Package cancelled',
  'purchases.adjusted': 'Sessions updated',
  'purchases.refunded': 'Refund issued',
  'purchases.cancel_title': 'Cancel this package?',
  'purchases.cancel_message':
    'Cancel {name}’s "{package}"? The {left} sessions left can no longer be booked. No money is refunded unless you refund it too.',
  'purchases.cancel_button': 'Cancel package',
  'purchases.back': 'Keep it',
  'purchases.adjust_title': 'Adjust sessions used',
  'purchases.adjust_intro': '"{package}" has {total} sessions. Set how many have been used - for a visit you logged by hand.',
  'purchases.used_label': 'Sessions used',
  'purchases.used_error': 'Enter a whole number from 0 to {total}.',
  'purchases.refund_title': 'Refund this package',
  'purchases.refund_intro': '"{package}" was bought for {amount}.',

  'customer.title': 'Packages',
  'customer.description': 'Session packages they bought. {left} sessions left on active packages.',
  'customer.open': 'All packages',
};

export default bookingPackages;
